import { render, staticRenderFns } from "./importScreeningData.vue?vue&type=template&id=4f81ad4f&scoped=true&"
import script from "./importScreeningData.vue?vue&type=script&lang=js&"
export * from "./importScreeningData.vue?vue&type=script&lang=js&"
import style0 from "./importScreeningData.vue?vue&type=style&index=0&id=4f81ad4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f81ad4f",
  null
  
)

export default component.exports